var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16.857,
    height: 16.857,
    viewBox: "0 0 16.857 16.857",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1750",
    "data-name": "Rectangle 1750",
    width: 16.857,
    height: 16.857,
    transform: "translate(-2 -2)",
    fill: "none",
    stroke: "#16161a",
    strokeWidth: 1.6
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3136",
    "data-name": "Group 3136",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3135",
    "data-name": "Group 3135",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8480",
    "data-name": "Path 8480",
    d: "M6.715,13.229a6.492,6.492,0,0,1-3.141-.807.8.8,0,1,1,.776-1.4A4.912,4.912,0,1,0,2.407,9.08a.8.8,0,1,1-1.4.776,6.514,6.514,0,1,1,5.707,3.373Z",
    transform: "translate(-0.286 -0.286)",
    fill: "#16161a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8481",
    "data-name": "Path 8481",
    d: "M1,16.616a.8.8,0,0,1-.778-.986l.706-2.961a.8.8,0,0,1,1.556.371l-.4,1.695,1.695-.4a.8.8,0,0,1,.371,1.556l-2.961.706A.8.8,0,0,1,1,16.616Z",
    transform: "translate(-0.286 -3.673)",
    fill: "#16161a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8482",
    "data-name": "Path 8482",
    d: "M5.156,7.473a1.319,1.319,0,1,1-1.32,1.319A1.321,1.321,0,0,1,5.156,7.473Z",
    transform: "translate(-1.325 -2.364)",
    fill: "#16161a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8483",
    "data-name": "Path 8483",
    d: "M8.792,7.473a1.319,1.319,0,1,1-1.32,1.319A1.321,1.321,0,0,1,8.792,7.473Z",
    transform: "translate(-2.363 -2.364)",
    fill: "#16161a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8484",
    "data-name": "Path 8484",
    d: "M12.429,7.473a1.319,1.319,0,1,1-1.32,1.319A1.321,1.321,0,0,1,12.429,7.473Z",
    transform: "translate(-3.403 -2.364)",
    fill: "#16161a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.e8ae893df8a0cdad1836bdc14692f776.svg";
export { ForwardRef as ReactComponent };